import { createSlice } from '@reduxjs/toolkit';

import type { ICourseV2 } from '@/Module/Lesson/Model/DataModel';
import { getCourseListAction } from '@/Module/Lesson/Store/Action';

const CourseSlice = createSlice({
  name: 'Course',
  initialState: {
    isLoading: false,
    Courses: [] as ICourseV2[] | [],
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getCourseListAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(getCourseListAction.rejected, state => {
        state.isLoading = false;
      })
      .addCase(getCourseListAction.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.Courses = payload;
      });
  },
});
export default CourseSlice;
